import React, { Suspense } from 'react'

const ClientRoutes = React.lazy(() => import('./client'))
const MemberRoutes = React.lazy(() => import('./member'))
const LpRoutes = React.lazy(() => import('./lp'))

const Routes: React.FC = () => {
  const pathname = window.location.pathname
  const isClientPath = pathname.startsWith('/client')
  const isLpPath = pathname.startsWith('/lp')

  return (
    <Suspense fallback={null}>
      {isClientPath ? <ClientRoutes /> : isLpPath ? <LpRoutes /> : <MemberRoutes />}
    </Suspense>
  )
}

export default Routes